// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Position the toggle at the bottom right of each card */
.card {
	position: relative;
}
.card__toggle {
	position: absolute;
	right: 16px;
	bottom: 16px;
	z-index: 5;
}

.category-dropdown-menu {
	position: absolute;
	top: 160%;
	left: -260%;
	transform: translateY(-100%);
	background: #ffffff;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0,0,0,0.08);
	min-width: 120px;
	z-index: 100000;
	padding: 6px 0;
	white-space: nowrap;
}


@media (max-width: 1024px) {
	.category-dropdown-menu {
		right: -12px;
		left: auto;
		transform: translateY(0);
		top: 100%;
		min-width: 140px;
	}
}


.category-dropdown-item {
	padding: 8px 16px;
	cursor: pointer;
	color: #141313a7;
	transition: background 0.15s;

	&:hover {
		background: #004996;
		color: #ffffff;
		border-radius: 8px;
	}
}

@media (max-width: 768px) {
	.category-dropdown-item {
		padding: 10px 16px;
		min-height: 40px;
		display: flex;
		align-items: center;
		gap: 8px;
	}
}
.categories-container {
	margin: 30px 100px;
}

@media (max-width: 1200px) {
	.categories-container {
		margin: 30px 50px;
	}
}

@media (max-width: 900px) {
	.categories-container {
		margin: 20px 30px;
		padding: 0;
	}
}

@media (max-width: 600px) {
	.categories-container {
		margin: 15px;
		padding: 0;
	}
}

.category-item {
	position: relative;
	border-radius: 8px;
	min-height: 60px;
	display: flex;
	align-items: center;
	cursor: pointer;
    margin-top: 10px;
	overflow: visible;
}

.category-item:hover{
	scale: 1.001;
}

@media (max-width: 768px) {
	.category-item {
		min-height: 50px;
		margin-top: 8px;
	}
}

.category-item-child {
	margin-left: 32px;
	padding-left: 24px;
    margin-top: 10px;
    margin-bottom: 10px;
}

@media (max-width: 768px) {
	.category-item-child {
		margin-left: 16px;
		padding-left: 12px;
		margin-top: 8px;
		margin-bottom: 8px;
	}
}

.category-tree-vert {
	position: absolute;
	left: 8px;
	top: 0;
	bottom: 0;
	width: 2px;
	background: #e5e7eb;
	z-index: 0;
	border-radius: 1px;
}

.category-tree-vert-last {
	bottom: 50%;
}

.category-tree-horiz {
	position: absolute;
	left: 8px;
	top: 50%;
	width: 16px;
	height: 2px;
	background: #e5e7eb;
	z-index: 0;
	transform: translateY(-50%);
}



.modal-content .form-headerr{
	/* gap: 0 !important; */
}

/* .category-item-child .category-content .tg-list{
	display: none;
} */

.category-content {
	display: flex;
	align-items: center;
	position: relative;
	width: 100%;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	border-radius: 12px;
	padding: 15px;
	padding-right: 12px;
	background: #ffffff;
	overflow: visible;
}

.category-content-fam{
	display: flex;
	align-items: center;
	position: relative;
	width: 100%;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	border-radius: 12px;
	padding: 15px;
	padding-right: 12px;
	background: #ffffff;
	overflow: visible;



}

@media (max-width: 768px) {
	.category-content {
		padding: 10px;
		padding-right: 8px;
		border-radius: 8px;
	}
}

@media (max-width: 480px) {
	.category-content {
		padding: 8px;
		padding-right: 6px;
		border-radius: 6px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
	}
}


.downArrow {
	margin-left: auto;
	display: flex;
	align-items: center;
	color: #0A4DA2;
}

.category-toggle {
	display: flex;
	align-items: center;
	margin-right: 8px;
}

.category-toggle-placeholder {
	width: 28px;
	display: inline-block;
}

.category-icon {
	/* Remove any previous background here if present */
}

.category-icon-bg {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	background: #004996;
	border-radius: 50%;
	margin-right: 10px;
}

.category-image {
	width: 50px;
	height: 50px;
	border-radius: 8px;
	object-fit: cover;
	margin-right: 15px;
	flex-shrink: 0;
}

@media (max-width: 768px) {
	.category-icon-bg {
		width: 32px;
		height: 32px;
		margin-right: 8px;
	}
	
	.category-image {
		width: 45px;
		height: 45px;
		margin-right: 10px;
	}
}

@media (max-width: 480px) {
	.category-icon-bg {
		width: 28px;
		height: 28px;
	}
	
	.category-icon-bg svg {
		width: 16px;
		height: 16px;
	}
	
	.category-image {
		width: 40px;
		height: 40px;
		margin-right: 8px;
	}
}

.category-names{
	color: #0A4DA2;
	font-weight: 500;
	text-decoration: none;
	margin-right: 10px;
	display: flex;
	flex-direction: column;
	min-width: 0;
	margin-left: 10px;
	word-break: break-word;
}

@media (max-width: 768px) {
	.category-names {
		margin-right: 8px;
	}
}

@media (max-width: 480px) {
	.category-names {
		margin-right: 5px;
	}
}

.category-name {
	color: #0A4DA2;
	font-weight: 500;
	text-decoration: none;
}




/* detail category css */
.DetailsSection{
	display: flex;
	flex-direction: column;
	margin-left: 20px;
	color: #004996;

	h3{
		display: flex;
		align-items: center;
	}
}

.commonBtn{
	margin-left: auto;
	flex-shrink: 0;
}

@media(max-width: 700px){
	.commonBtn {
		margin: 0;
	}
}

.both{
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
}

@media (max-width: 480px) {
	.both {
		gap: 5px;
	}
}

.common{
	background: #60A92C;
	color: #ffffff;
	padding: 8px 16px;
	border-radius: 30px;
}

.commonBtn button{
	background: none;
	padding: 8px 16px;
	border-radius: 30px;
	border: none;
	cursor: pointer;
	min-width: 36px;
	min-height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
}

@media (max-width: 768px) {
	.commonBtn button {
		padding: 6px 12px;
		min-width: 40px;
		min-height: 40px;
	}
}

@media (max-width: 480px) {
	.commonBtn button {
		padding: 5px 10px;
		min-width: 38px;
		min-height: 38px;
	}
}
/* Ensure DetailPage can scroll if content overflows */
.DetailPage {
	width: 100%;
	min-height: 100vh;
	overflow-y: auto;
}

.DetailPage .category-content{
	@media(max-width: 700px){
		flex-wrap: wrap;
	}
}

/* Responsive form button group */

.form-button-group {
	display: flex;
	gap: 10px;
	justify-content: flex-end;
	margin-top: 20px;
	flex-wrap: wrap;
}

.form-button-group .commonBtn {
	padding: 10px 20px;
	border-radius: 4px;
	cursor: pointer;
	transition: all 0.2s ease;
}

@media (max-width: 480px) {
	.form-button-group {
		flex-direction: row;
		justify-content: center;
		gap: 8px;
	}
	
	.form-button-group .commonBtn {
		width: 100%;
		padding: 12px 20px;
	}
}

/* Responsive form labels and inputs */
.modal input,
.modal select,
.modal textarea {
	width: 100%;
	box-sizing: border-box;
}

@media (max-width: 768px) {
	.modal input,
	.modal select,
	.modal textarea {
	}
}
/* Additional mobile responsive improvements */
@media (max-width: 600px) {
	.category-item {
		min-height: 44px;
		margin-top: 6px;
	}
	
	.category-item-child {
		margin-left: 12px;
		padding-left: 8px;
		margin-top: 6px;
		margin-bottom: 6px;
	}
}

@media (max-width: 480px) {
	.categories-container {
		margin: 0;
	}
	
	.category-item {
		min-height: 40px;
		margin-top: 5px;
	}
	
	.category-item-child {
		margin-left: 8px;
		padding-left: 6px;
		margin-top: 5px;
		margin-bottom: 5px;
	}
	
	.category-content {
		padding: 6px 8px;
	}
	
	.category-name {
		font-size: 14px;
		line-height: 1.3;
	}
	
	.drag-handle {
		margin-right: 4px !important;
		margin-left: 2px !important;
	}
}

@media (max-width: 360px) {
	.categories-container {
		margin: 0;
	}
	
	.category-content {
		padding: 5px 6px;
	}
	
	.category-name {
		font-size: 13px;
	}
	
	.category-icon-bg {
		width: 26px;
		height: 26px;
		margin-right: 6px;
	}
	
	.category-icon-bg svg {
		width: 14px;
		height: 14px;
	}
}

/* Drag and drop styles for all devices */
.drag-handle {
cursor: grab;
touch-action: none;
-webkit-user-select: none;
user-select: none;
display: flex;
align-items: center;
justify-content: center;
flex-shrink: 0;
}

.drag-handle:active {
cursor: grabbing;
}

/* Sortable ghost element when dragging */
.sortable-ghost {
opacity: 0.4;
background: #e3f2fd;
border: 2px dashed #0A4DA2;
border-radius: 8px;
}

.sortable-chosen {
cursor: grabbing !important;
}

.sortable-drag {
opacity: 1;
background: #fff;
box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
border-radius: 8px;
}

/* Better touch targets for mobile drag handles */
@media (max-width: 768px) {
.drag-handle {
min-width: 32px;
min-height: 32px;
padding: 4px;
}
}

@media (max-width: 480px) {
.drag-handle {
min-width: 36px;
min-height: 36px;
padding: 6px;
}

.sortable-ghost {
border-width: 1px;
}
}

/* Prevent text selection during drag on mobile */
.sortable-fallback {
opacity: 0 !important;
}


/* Drag and drop styles for all devices */
.drag-handle {
	cursor: grab;
	touch-action: none;
	-webkit-user-select: none;
	user-select: none;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}

.drag-handle:active {
	cursor: grabbing;
}

/* Sortable ghost element when dragging */
.sortable-ghost {
	opacity: 0.4;
	background: #e3f2fd;
	border: 2px dashed #0A4DA2;
	border-radius: 8px;
}

.sortable-chosen {
	cursor: grabbing !important;
}

.sortable-drag {
	opacity: 1;
	background: #fff;
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
	border-radius: 8px;
}

/* Better touch targets for mobile drag handles */
@media (max-width: 768px) {
	.drag-handle {
		min-width: 32px;
		min-height: 32px;
		padding: 4px;
	}
}

@media (max-width: 480px) {
	.drag-handle {
		min-width: 26px;
		min-height: 26px;
		padding: 6px;
	}
	
	.sortable-ghost {
		border-width: 1px;
	}
}

/* Prevent text selection during drag on mobile */
.sortable-fallback {
	opacity: 0 !important;
}
.distributor-action-dropdown-menu {
  position: absolute;
  right: 0;
  left: unset;
  top: 240%;
  margin-top: 5px;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-radius: 8px;
  z-index: 1000;
  width: 140px;
  border: 1px solid #e9ecef;
}

@media (max-width: 1200px) {
  .distributor-action-dropdown-menu {
    top: 20%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/category.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,4BAA4B;CAC5B,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,sCAAsC;CACtC,gBAAgB;CAChB,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;;;AAGA;CACC;EACC,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,SAAS;EACT,gBAAgB;CACjB;AACD;;;AAGA;CACC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,4BAA4B;;CAE5B;EACC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;CACT;AACD;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB,UAAU;CACX;AACD;;AAEA;CACC;EACC,YAAY;EACZ,UAAU;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,eAAe;IACZ,gBAAgB;CACnB,iBAAiB;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC;EACC,gBAAgB;EAChB,eAAe;CAChB;AACD;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;CACC;EACC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;CACnB;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,MAAM;CACN,SAAS;CACT,UAAU;CACV,mBAAmB;CACnB,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,UAAU;CACV,2BAA2B;AAC5B;;;;AAIA;CACC,uBAAuB;AACxB;;AAEA;;GAEG;;AAEH;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,wCAAwC;CACxC,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,wCAAwC;CACxC,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,iBAAiB;;;;AAIlB;;AAEA;CACC;EACC,aAAa;EACb,kBAAkB;EAClB,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;CAC1C;AACD;;;AAGA;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mDAAmD;AACpD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,iBAAiB;CAClB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,iBAAiB;CAClB;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,qBAAqB;AACtB;;;;;AAKA,wBAAwB;AACxB;CACC,aAAa;CACb,sBAAsB;CACtB,iBAAiB;CACjB,cAAc;;CAEd;EACC,aAAa;EACb,mBAAmB;CACpB;AACD;;AAEA;CACC,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC;EACC,SAAS;CACV;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC;EACC,QAAQ;CACT;AACD;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC;EACC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;CACjB;AACD;AACA,sDAAsD;AACtD;CACC,WAAW;CACX,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA,iCAAiC;;AAEjC;CACC,aAAa;CACb,SAAS;CACT,yBAAyB;CACzB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC;EACC,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;CACT;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,sCAAsC;AACtC;;;CAGC,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC;;;CAGA;AACD;AACA,8CAA8C;AAC9C;CACC;EACC,gBAAgB;EAChB,eAAe;CAChB;;CAEA;EACC,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,SAAS;CACV;;CAEA;EACC,gBAAgB;EAChB,eAAe;CAChB;;CAEA;EACC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,4BAA4B;EAC5B,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,SAAS;CACV;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,iBAAiB;CAClB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;AACD;;AAEA,yCAAyC;AACzC;AACA,YAAY;AACZ,kBAAkB;AAClB,yBAAyB;AAGzB,iBAAiB;AACjB,aAAa;AACb,mBAAmB;AACnB,uBAAuB;AACvB,cAAc;AACd;;AAEA;AACA,gBAAgB;AAChB;;AAEA,yCAAyC;AACzC;AACA,YAAY;AACZ,mBAAmB;AACnB,0BAA0B;AAC1B,kBAAkB;AAClB;;AAEA;AACA,2BAA2B;AAC3B;;AAEA;AACA,UAAU;AACV,gBAAgB;AAChB,yCAAyC;AACzC,kBAAkB;AAClB;;AAEA,iDAAiD;AACjD;AACA;AACA,eAAe;AACf,gBAAgB;AAChB,YAAY;AACZ;AACA;;AAEA;AACA;AACA,eAAe;AACf,gBAAgB;AAChB,YAAY;AACZ;;AAEA;AACA,iBAAiB;AACjB;AACA;;AAEA,iDAAiD;AACjD;AACA,qBAAqB;AACrB;;;AAGA,yCAAyC;AACzC;CACC,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CAGzB,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA,yCAAyC;AACzC;CACC,YAAY;CACZ,mBAAmB;CACnB,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,yCAAyC;CACzC,kBAAkB;AACnB;;AAEA,iDAAiD;AACjD;CACC;EACC,eAAe;EACf,gBAAgB;EAChB,YAAY;CACb;AACD;;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;EAChB,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA,iDAAiD;AACjD;CACC,qBAAqB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,QAAQ;EACV;AACF","sourcesContent":["/* Position the toggle at the bottom right of each card */\n.card {\n\tposition: relative;\n}\n.card__toggle {\n\tposition: absolute;\n\tright: 16px;\n\tbottom: 16px;\n\tz-index: 5;\n}\n\n.category-dropdown-menu {\n\tposition: absolute;\n\ttop: 160%;\n\tleft: -260%;\n\ttransform: translateY(-100%);\n\tbackground: #ffffff;\n\tborder: 1px solid #e5e7eb;\n\tborder-radius: 8px;\n\tbox-shadow: 0 2px 8px rgba(0,0,0,0.08);\n\tmin-width: 120px;\n\tz-index: 100000;\n\tpadding: 6px 0;\n\twhite-space: nowrap;\n}\n\n\n@media (max-width: 1024px) {\n\t.category-dropdown-menu {\n\t\tright: -12px;\n\t\tleft: auto;\n\t\ttransform: translateY(0);\n\t\ttop: 100%;\n\t\tmin-width: 140px;\n\t}\n}\n\n\n.category-dropdown-item {\n\tpadding: 8px 16px;\n\tcursor: pointer;\n\tcolor: #141313a7;\n\ttransition: background 0.15s;\n\n\t&:hover {\n\t\tbackground: #004996;\n\t\tcolor: #ffffff;\n\t\tborder-radius: 8px;\n\t}\n}\n\n@media (max-width: 768px) {\n\t.category-dropdown-item {\n\t\tpadding: 10px 16px;\n\t\tmin-height: 40px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t}\n}\n.categories-container {\n\tmargin: 30px 100px;\n}\n\n@media (max-width: 1200px) {\n\t.categories-container {\n\t\tmargin: 30px 50px;\n\t}\n}\n\n@media (max-width: 900px) {\n\t.categories-container {\n\t\tmargin: 20px 30px;\n\t\tpadding: 0;\n\t}\n}\n\n@media (max-width: 600px) {\n\t.categories-container {\n\t\tmargin: 15px;\n\t\tpadding: 0;\n\t}\n}\n\n.category-item {\n\tposition: relative;\n\tborder-radius: 8px;\n\tmin-height: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n    margin-top: 10px;\n\toverflow: visible;\n}\n\n.category-item:hover{\n\tscale: 1.001;\n}\n\n@media (max-width: 768px) {\n\t.category-item {\n\t\tmin-height: 50px;\n\t\tmargin-top: 8px;\n\t}\n}\n\n.category-item-child {\n\tmargin-left: 32px;\n\tpadding-left: 24px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n@media (max-width: 768px) {\n\t.category-item-child {\n\t\tmargin-left: 16px;\n\t\tpadding-left: 12px;\n\t\tmargin-top: 8px;\n\t\tmargin-bottom: 8px;\n\t}\n}\n\n.category-tree-vert {\n\tposition: absolute;\n\tleft: 8px;\n\ttop: 0;\n\tbottom: 0;\n\twidth: 2px;\n\tbackground: #e5e7eb;\n\tz-index: 0;\n\tborder-radius: 1px;\n}\n\n.category-tree-vert-last {\n\tbottom: 50%;\n}\n\n.category-tree-horiz {\n\tposition: absolute;\n\tleft: 8px;\n\ttop: 50%;\n\twidth: 16px;\n\theight: 2px;\n\tbackground: #e5e7eb;\n\tz-index: 0;\n\ttransform: translateY(-50%);\n}\n\n\n\n.modal-content .form-headerr{\n\t/* gap: 0 !important; */\n}\n\n/* .category-item-child .category-content .tg-list{\n\tdisplay: none;\n} */\n\n.category-content {\n\tdisplay: flex;\n\talign-items: center;\n\tposition: relative;\n\twidth: 100%;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\tborder-radius: 12px;\n\tpadding: 15px;\n\tpadding-right: 12px;\n\tbackground: #ffffff;\n\toverflow: visible;\n}\n\n.category-content-fam{\n\tdisplay: flex;\n\talign-items: center;\n\tposition: relative;\n\twidth: 100%;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\tborder-radius: 12px;\n\tpadding: 15px;\n\tpadding-right: 12px;\n\tbackground: #ffffff;\n\toverflow: visible;\n\n\n\n}\n\n@media (max-width: 768px) {\n\t.category-content {\n\t\tpadding: 10px;\n\t\tpadding-right: 8px;\n\t\tborder-radius: 8px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.category-content {\n\t\tpadding: 8px;\n\t\tpadding-right: 6px;\n\t\tborder-radius: 6px;\n\t\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n\t}\n}\n\n\n.downArrow {\n\tmargin-left: auto;\n\tdisplay: flex;\n\talign-items: center;\n\tcolor: #0A4DA2;\n}\n\n.category-toggle {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 8px;\n}\n\n.category-toggle-placeholder {\n\twidth: 28px;\n\tdisplay: inline-block;\n}\n\n.category-icon {\n\t/* Remove any previous background here if present */\n}\n\n.category-icon-bg {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 36px;\n\theight: 36px;\n\tbackground: #004996;\n\tborder-radius: 50%;\n\tmargin-right: 10px;\n}\n\n.category-image {\n\twidth: 50px;\n\theight: 50px;\n\tborder-radius: 8px;\n\tobject-fit: cover;\n\tmargin-right: 15px;\n\tflex-shrink: 0;\n}\n\n@media (max-width: 768px) {\n\t.category-icon-bg {\n\t\twidth: 32px;\n\t\theight: 32px;\n\t\tmargin-right: 8px;\n\t}\n\t\n\t.category-image {\n\t\twidth: 45px;\n\t\theight: 45px;\n\t\tmargin-right: 10px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.category-icon-bg {\n\t\twidth: 28px;\n\t\theight: 28px;\n\t}\n\t\n\t.category-icon-bg svg {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n\t\n\t.category-image {\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tmargin-right: 8px;\n\t}\n}\n\n.category-names{\n\tcolor: #0A4DA2;\n\tfont-weight: 500;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-width: 0;\n\tmargin-left: 10px;\n\tword-break: break-word;\n}\n\n@media (max-width: 768px) {\n\t.category-names {\n\t\tmargin-right: 8px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.category-names {\n\t\tmargin-right: 5px;\n\t}\n}\n\n.category-name {\n\tcolor: #0A4DA2;\n\tfont-weight: 500;\n\ttext-decoration: none;\n}\n\n\n\n\n/* detail category css */\n.DetailsSection{\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-left: 20px;\n\tcolor: #004996;\n\n\th3{\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n}\n\n.commonBtn{\n\tmargin-left: auto;\n\tflex-shrink: 0;\n}\n\n@media(max-width: 700px){\n\t.commonBtn {\n\t\tmargin: 0;\n\t}\n}\n\n.both{\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 10px;\n}\n\n@media (max-width: 480px) {\n\t.both {\n\t\tgap: 5px;\n\t}\n}\n\n.common{\n\tbackground: #60A92C;\n\tcolor: #ffffff;\n\tpadding: 8px 16px;\n\tborder-radius: 30px;\n}\n\n.commonBtn button{\n\tbackground: none;\n\tpadding: 8px 16px;\n\tborder-radius: 30px;\n\tborder: none;\n\tcursor: pointer;\n\tmin-width: 36px;\n\tmin-height: 36px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n@media (max-width: 768px) {\n\t.commonBtn button {\n\t\tpadding: 6px 12px;\n\t\tmin-width: 40px;\n\t\tmin-height: 40px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.commonBtn button {\n\t\tpadding: 5px 10px;\n\t\tmin-width: 38px;\n\t\tmin-height: 38px;\n\t}\n}\n/* Ensure DetailPage can scroll if content overflows */\n.DetailPage {\n\twidth: 100%;\n\tmin-height: 100vh;\n\toverflow-y: auto;\n}\n\n.DetailPage .category-content{\n\t@media(max-width: 700px){\n\t\tflex-wrap: wrap;\n\t}\n}\n\n/* Responsive form button group */\n\n.form-button-group {\n\tdisplay: flex;\n\tgap: 10px;\n\tjustify-content: flex-end;\n\tmargin-top: 20px;\n\tflex-wrap: wrap;\n}\n\n.form-button-group .commonBtn {\n\tpadding: 10px 20px;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: all 0.2s ease;\n}\n\n@media (max-width: 480px) {\n\t.form-button-group {\n\t\tflex-direction: row;\n\t\tjustify-content: center;\n\t\tgap: 8px;\n\t}\n\t\n\t.form-button-group .commonBtn {\n\t\twidth: 100%;\n\t\tpadding: 12px 20px;\n\t}\n}\n\n/* Responsive form labels and inputs */\n.modal input,\n.modal select,\n.modal textarea {\n\twidth: 100%;\n\tbox-sizing: border-box;\n}\n\n@media (max-width: 768px) {\n\t.modal input,\n\t.modal select,\n\t.modal textarea {\n\t}\n}\n/* Additional mobile responsive improvements */\n@media (max-width: 600px) {\n\t.category-item {\n\t\tmin-height: 44px;\n\t\tmargin-top: 6px;\n\t}\n\t\n\t.category-item-child {\n\t\tmargin-left: 12px;\n\t\tpadding-left: 8px;\n\t\tmargin-top: 6px;\n\t\tmargin-bottom: 6px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.categories-container {\n\t\tmargin: 0;\n\t}\n\t\n\t.category-item {\n\t\tmin-height: 40px;\n\t\tmargin-top: 5px;\n\t}\n\t\n\t.category-item-child {\n\t\tmargin-left: 8px;\n\t\tpadding-left: 6px;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 5px;\n\t}\n\t\n\t.category-content {\n\t\tpadding: 6px 8px;\n\t}\n\t\n\t.category-name {\n\t\tfont-size: 14px;\n\t\tline-height: 1.3;\n\t}\n\t\n\t.drag-handle {\n\t\tmargin-right: 4px !important;\n\t\tmargin-left: 2px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.categories-container {\n\t\tmargin: 0;\n\t}\n\t\n\t.category-content {\n\t\tpadding: 5px 6px;\n\t}\n\t\n\t.category-name {\n\t\tfont-size: 13px;\n\t}\n\t\n\t.category-icon-bg {\n\t\twidth: 26px;\n\t\theight: 26px;\n\t\tmargin-right: 6px;\n\t}\n\t\n\t.category-icon-bg svg {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n}\n\n/* Drag and drop styles for all devices */\n.drag-handle {\ncursor: grab;\ntouch-action: none;\n-webkit-user-select: none;\n-moz-user-select: none;\n-ms-user-select: none;\nuser-select: none;\ndisplay: flex;\nalign-items: center;\njustify-content: center;\nflex-shrink: 0;\n}\n\n.drag-handle:active {\ncursor: grabbing;\n}\n\n/* Sortable ghost element when dragging */\n.sortable-ghost {\nopacity: 0.4;\nbackground: #e3f2fd;\nborder: 2px dashed #0A4DA2;\nborder-radius: 8px;\n}\n\n.sortable-chosen {\ncursor: grabbing !important;\n}\n\n.sortable-drag {\nopacity: 1;\nbackground: #fff;\nbox-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\nborder-radius: 8px;\n}\n\n/* Better touch targets for mobile drag handles */\n@media (max-width: 768px) {\n.drag-handle {\nmin-width: 32px;\nmin-height: 32px;\npadding: 4px;\n}\n}\n\n@media (max-width: 480px) {\n.drag-handle {\nmin-width: 36px;\nmin-height: 36px;\npadding: 6px;\n}\n\n.sortable-ghost {\nborder-width: 1px;\n}\n}\n\n/* Prevent text selection during drag on mobile */\n.sortable-fallback {\nopacity: 0 !important;\n}\n\n\n/* Drag and drop styles for all devices */\n.drag-handle {\n\tcursor: grab;\n\ttouch-action: none;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-shrink: 0;\n}\n\n.drag-handle:active {\n\tcursor: grabbing;\n}\n\n/* Sortable ghost element when dragging */\n.sortable-ghost {\n\topacity: 0.4;\n\tbackground: #e3f2fd;\n\tborder: 2px dashed #0A4DA2;\n\tborder-radius: 8px;\n}\n\n.sortable-chosen {\n\tcursor: grabbing !important;\n}\n\n.sortable-drag {\n\topacity: 1;\n\tbackground: #fff;\n\tbox-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n\tborder-radius: 8px;\n}\n\n/* Better touch targets for mobile drag handles */\n@media (max-width: 768px) {\n\t.drag-handle {\n\t\tmin-width: 32px;\n\t\tmin-height: 32px;\n\t\tpadding: 4px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.drag-handle {\n\t\tmin-width: 26px;\n\t\tmin-height: 26px;\n\t\tpadding: 6px;\n\t}\n\t\n\t.sortable-ghost {\n\t\tborder-width: 1px;\n\t}\n}\n\n/* Prevent text selection during drag on mobile */\n.sortable-fallback {\n\topacity: 0 !important;\n}\n.distributor-action-dropdown-menu {\n  position: absolute;\n  right: 0;\n  left: unset;\n  top: 240%;\n  margin-top: 5px;\n  background-color: #fff;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  border-radius: 8px;\n  z-index: 1000;\n  width: 140px;\n  border: 1px solid #e9ecef;\n}\n\n@media (max-width: 1200px) {\n  .distributor-action-dropdown-menu {\n    top: 20%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
